// @flow

import React, { type Node, useState } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import isEmpty from 'lodash-es/isEmpty';

import type { Pet } from '@rover/react-lib/types';
import { VetInfoConstants } from '@rover/app/js/constants/translationConstants';

import PetVetInfo from './PetVetInfo';
import SectionTitle from '../common/SectionTitle';
import SectionSaveButton from '../common/SectionSaveButton';

type Props = {
  pets: Array<Pet>,
  handleSave: () => void,
  handleUpdate: (pet: Pet) => void,
  isVetComplete: boolean,
};

const SectionWrapper: StyledComponent<{}> = styled.div`
  margin-left: 45px;
  margin-right: 45px;
`;

const VetInfo = ({ pets, handleSave, handleUpdate, isVetComplete }: Props): Node => {
  const [currentlyEditing, setCurrentlyEditing] = useState({});

  const toggleEditing = pet =>
    setCurrentlyEditing({ ...currentlyEditing, [pet.url]: !currentlyEditing[pet.url] });

  const isFormComplete = isEmpty(currentlyEditing) && isVetComplete;

  const save = () => {
    handleSave();
    setCurrentlyEditing({});
  };

  pets.forEach(pet => {
    if (!pet.veterinaryInformation && !currentlyEditing[pet.url]) {
      toggleEditing(pet);
    }
  });

  return (
    <SectionWrapper>
      <SectionTitle isComplete={isFormComplete} titleText={VetInfoConstants.title} />
      {pets.map(pet => (
        <PetVetInfo
          key={pet.url}
          pet={pet}
          hasMultiplePets={pets.length > 1}
          handleVetInfoChange={(veterinaryInformation: string) =>
            handleUpdate({ ...pet, veterinaryInformation })
          }
          value={pet.veterinaryInformation}
          isEditing={currentlyEditing[pet.url]}
          toggleEditing={toggleEditing}
        />
      ))}
      <SectionSaveButton
        isComplete={isFormComplete}
        buttonText={VetInfoConstants.save}
        saveMethod={save}
        currentlyEditing={currentlyEditing}
      />
    </SectionWrapper>
  );
};

export default VetInfo;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/VetInfo.jsx